<template>
  <div class="card-job-form">
    <Task
      :entityId="cardId"
      :createTask="createTask"
      :updateTask="updateTask"
      editEventName="jobCardEdit"
      savedEventName="jobSaved"
      triggerLabel="Adicionar tarefa"
    />

    <CardJobList :cardId="cardId" @count-change="$emit('count-change', $event)" />
  </div>
</template>

<script>
import Task from "@/ui/layout/Task.vue";

import CardJobList from "./JobList.vue";

import CardService from "../../services/card.service";

export default {
  name: "CardJobForm",
  components: { Task, CardJobList },
  props: {
    cardId: {
      type: String,
      required: true,
    },
  },
  methods: {
    createTask(task) {
      return CardService.createJob({ ...task, genericId: task.entityId, listGuest: [] });
    },
    updateTask(task) {
      return CardService.updateJob({ ...task, genericId: task.entityId, listGuest: [] });
    },
  },
};
</script>

<style scoped>
.card-job-form {
  display: flex;
  flex-direction: column;
}
</style>
